module.exports = __webpack_public_path__ + "img/has-data.8e131856.png";